import { CommonContentWrapper } from "../../common/components/content_wrapper/CommonContentWrapper";
import { Padding, Row } from "../../common/components/CommonBaseComponents";
import { PageTitle } from "../../common/components/PageTitle";
import CustomTab from "../../common/components/tab/CustomTab";
import { useRef, useState } from "react";
import NoticeTabContent from "./tabs/NoticeTabContent";
import FAQTabContent from "./tabs/FAQTabContent";
import { useSearchParams } from "react-router-dom";
import FAQSaveContent from "./tabs/FAQSaveContent";
import CustomPopup from "../../common/components/popup/CustomPopup";
import Translate from "../../common/translate/Translate";
import PrimaryButton from "../../common/components/button/PrimaryButton";
import CourseImageTabContent from "./tabs/CourseImageTabContent";
import CourseAddImageModal from "./modals/CourseAddImageModal";

const tabs = [
    { value: "Notice", label: Translate("settings.notice") },
    { value: "FAQContents", label: "Guide" },
    { value: "CourseImage", label: Translate("settings.courseImage") },
];

export function SettingPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "Notice";

    const handleSetTab = (tabValue) => {
        if (searchParams.get("isSavePage") === "true") {
            setIsCancelPopupOpen(true);
            wantToGoTab.current = tabValue;
            return;
        }

        setSearchParams({ tab: tabValue }, { replace: true });
    };

    const handleAddFAQContent = () => {
        setSearchParams({ tab: "FAQContents", isSavePage: "true" });
    };

    // start: FAQ Save Content 취소시 팝업 상태 및 팝업 버튼 액션
    const noticeTabRef = useRef(null);
    const wantToGoTab = useRef("");
    const cancelActionTypeRef = useRef("");
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };

    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);
        if (cancelActionTypeRef.current === "button") {
            setSearchParams({ tab: "FAQContents" }, { replace: true });
            cancelActionTypeRef.current = "";
            return;
        }
        setSearchParams({ tab: wantToGoTab.current }, { replace: true });
    };
    // end: FAQ Save Content 취소시 팝업 상태 및 팝업 버튼 액션

    const [hasFAQData, setHasFAQData] = useState(false);

    // 이미지 추가 모달
    const [openAddImage, setOpenAddImage] = useState(false);

    return (
        <CommonContentWrapper
            hasPagination={
                activeTab === "CourseImage" || (activeTab === "FAQContents" && !searchParams.get("isSavePage"))
            }
        >
            <Padding padding={"24px 20px"}>
                <PageTitle title={Translate("gnb.setting")} />
                <Padding padding={"24px 12px"}>
                    <Row width={"100%"} justifyContent={"space-between"}>
                        <CustomTab tabs={tabs} activeTab={activeTab} onClick={handleSetTab} />
                        {activeTab === "FAQContents" && !searchParams.get("isSavePage") && hasFAQData && (
                            <PrimaryButton
                                icon={"add_white"}
                                text={Translate("setting.addContent")}
                                onClick={handleAddFAQContent}
                            />
                        )}
                        {activeTab === "CourseImage" && (
                            <PrimaryButton
                                icon={"add_white"}
                                text={Translate("common.addImage")}
                                onClick={() => setOpenAddImage(true)}
                            />
                        )}
                    </Row>
                    {activeTab === "Notice" && <NoticeTabContent ref={noticeTabRef} />}
                    {activeTab === "FAQContents" && !searchParams.get("isSavePage") && (
                        <FAQTabContent onDataChange={setHasFAQData} />
                    )}
                    {activeTab === "FAQContents" && searchParams.get("isSavePage") === "true" && (
                        <FAQSaveContent
                            onCancelClick={() => {
                                cancelActionTypeRef.current = "button";
                                setIsCancelPopupOpen(true);
                            }}
                        />
                    )}
                    {activeTab === "CourseImage" && <CourseImageTabContent />}
                </Padding>
            </Padding>
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
            {openAddImage && <CourseAddImageModal isOpen={openAddImage} onClose={() => setOpenAddImage(false)} />}
        </CommonContentWrapper>
    );
}
